import React, { useRef, useEffect } from "react";
import product1 from "../assets/product1.jpg";
import product2 from "../assets/product2.jpg";
import product3 from "../assets/product3.png";
import product4 from "../assets/product4.png";
import product5 from "../assets/product5.jpg";
import prodcut6 from "../assets/product6.jpg";

const Products = () => {
  const scrollRef = useRef(null);

  const products = [
    { id: 1, title: "Bricks", image: product1 },
    { id: 2, title: "Pavers", image: product2 },
    { id: 3, title: "Hollow Blocks", image: product3 },
    { id: 4, title: "Vertical Garden Blocks", image: product4 },
    { id: 5, title: "Modular Plantation Wall", image: product5 },
    { id:6,  title:"Circular Stones", image:prodcut6}
  ];

  const loopItems = [...products, ...products];

useEffect(() => {
  const container = scrollRef.current;
  if (!container) return;

  let isManualScrolling = false;

  const autoScroll = setInterval(() => {
    if (!isManualScrolling) {
      container.scrollLeft += 2.6;
      if (container.scrollLeft >= container.scrollWidth / 2) {
        container.scrollLeft = 0;
      }
    }
  }, 20);

  const stopAuto = () => {
    isManualScrolling = true;
  };

  const resumeAuto = () => {
    setTimeout(() => {
      isManualScrolling = false;
    }, 600); // wait smoothly after touch end
  };

  container.addEventListener("touchstart", stopAuto);
  container.addEventListener("touchmove", stopAuto);
  container.addEventListener("touchend", resumeAuto);

  return () => {
    clearInterval(autoScroll);
    container.removeEventListener("touchstart", stopAuto);
    container.removeEventListener("touchmove", stopAuto);
    container.removeEventListener("touchend", resumeAuto);
  };
}, []);


  return (
    <section id="products" style={{ padding: "3.5rem 0" }}>
      <div className="innovation-container">
        <div style={{ textAlign: "center", marginBottom: "2.5rem" }}>
          <div style={{ textTransform: "uppercase", fontSize: ".78rem", letterSpacing: ".18em", color: "#116530", fontWeight: 600 }}>
            Our Products
          </div>
          <h2 style={{ fontSize: "1.7rem", fontWeight: 700 }}>Supporting a greener future</h2>
        </div>

        {/* OUTER WRAPPER */}
        <div className="product-scroll-wrapper" ref={scrollRef}>
          {/* INNER SCROLLING TRACK */}
          <div className="product-scroll-track">
            {loopItems.map((p, i) => (
              <div className="product-card-carousel" key={i}>
                <img src={p.image} alt={p.title} className="product-img-carousel" />
                <h3>{p.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;
